export default __webpack_public_path__ + "static/media/online-voting.1c6047c1.svg";